import React, { useEffect, useState } from 'react';
import { PageHeading } from '../../../../SharedComponents';
import { TabsComponent } from '../../../../Components';
import { leadXChangeLocalePath } from '../I18n/LeadXChangeLocale';
import { useTranslation } from 'react-i18next';
import { GetAllEntitySources } from '../../../../Services/LeadXChangeServices/LeadXChangeServices';
import { showError } from '../../../../Helper';
import EntityRevenueConfiguration from './GeneralConfiguration/EntityRevenueConfiguration';
import CampaignConfiguration from './CampaignConfiguration/CampaignConfiguration';
import SLAConfiguration from './SLAConfiguration/SLAConfiguration';

export default function LeadXChangeConfiguration() {
  const { t: translate } = useTranslation(leadXChangeLocalePath);
  const [currentTab, setCurrentTab] = useState(0);
  const [entitySources, setEntitySources] = useState([]);
  const getAllEntitySources = async () => {
    try {
      const res = await GetAllEntitySources();
      setEntitySources(res);
    } catch (error) {
      showError('failed to fetch entity sources.');
    }
  };

  useEffect(() => {
    getAllEntitySources();
  }, []);

  const subTitleText = {
    0: 'configure_revenue_sharing',
    1: 'set_custom_commission_rules',
    2: 'set_automatic_return_rules',
  };
  return (
    <div className='propx-view leadxchange-view'>
      <div className='d-flex-v-center-h-between'>
        <PageHeading
          parentTranslationPath={leadXChangeLocalePath}
          headerTitle={'Configuration '}
          subTitle={subTitleText[currentTab]}
          wrapperClasses={'px-4 pt-4 w-75'}
          headerTitleClasses={'fz-30  mb-3'}
          subTitleClasses={'m-0'}
        />
      </div>
      <div className='main-tabs-container'>
        <TabsComponent
          wrapperClasses='main-tabs-wrapper'
          data={[
            {
              label: 'general_configuration',
              component: EntityRevenueConfiguration,
            },
            {
              label: 'campaign_configuration',
              component: CampaignConfiguration,
            },
            {
              label: 'SLA configuration ',
              component: SLAConfiguration,
            },
          ]}
          orientation='vertical'
          labelInput='label'
          parentTranslationPath={leadXChangeLocalePath}
          themeClasses='theme-propx'
          currentTab={currentTab}
          onTabChanged={(_, second) => setCurrentTab(second)}
          withDynamicComponents
          dynamicComponentProps={{
            parentTranslationPath: leadXChangeLocalePath,
            entitySources,
            translate,
          }}
        />
      </div>
    </div>
  );
}
